export default __webpack_public_path__ + "static/barfplan-blog-promo@3x-8b7057bf30c0d31a86dfc1e0b882b034.webp";